/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const activityHistory = usersList.injectEndpoints({
    tagTypes: ['Alerts',],
    endpoints: (builder) => ({
        getActivityHistoryList: builder.query({
            query: (searchParams) => ({
                url: `access-logs/consolidated-logs?${searchParams}`,
                method: 'GET',
               
            }),
            
        }),
        getExportHistoryList: builder.query({
            query: (searchParams) => ({
                url: `access-logs/list-export-history?${searchParams}`,
                method: 'GET',
               
            }),
            
        }),
        exportActivityHistoryExportLog:builder.mutation({
            query:({columns,dateformat})=>({
                url:`access-logs/export-history`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
        }),
        exportConsilatedActivityHistoryList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `access-logs/consolidated-logs/export?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }), 
        getAccessLogsList: builder.query({
            query: (searchParams) => ({
                url: `access-logs/consolidated-access-logs?${searchParams}`,
                method: 'GET',
               
            }),
            
        }),
        exportActivityLogList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `access-logs/export-access-logs?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }), 
        
    }),
   
    overrideExisting: false
})


export const {
    useGetActivityHistoryListQuery,
    useGetExportHistoryListQuery,
    useExportActivityHistoryExportLogMutation,
    useExportConsilatedActivityHistoryListMutation,
    useGetAccessLogsListQuery,
    useExportActivityLogListMutation

} = activityHistory

